<div class="modal-content">
  <div class="scrollable">
    @for (model of data?.models; track model.unitUUID) {
      <apm-header-description [title]="445060 | apmTranslate">
        <div class="my-2 d-flex flex-column">
          <span
            >{{ 445137 | apmTranslate }}: <b>{{ model.modelName }}</b></span
          >
          <span
            >{{ 445138 | apmTranslate }}: <b>{{ model.workingCondition }}</b></span
          >
        </div>
      </apm-header-description>

      <div class="my-2 d-flex flex-column">
        @for (performanceAccessory of groupedModels()[model.unitUUID] | keyvalue; track $index) {
          <div class="d-flex flex-column gap-2">
            <div class="d-flex flex-row">
              <span class="fw-bold flex-1">{{ 445135 | apmTranslate }}</span>
              <span class="fw-bold flex-1">{{ 445136 | apmTranslate }}</span>
            </div>
            <div class="d-flex flex-row align-items-center">
              <span class="flex-1"
                >{{ performanceAccessory.key }} -
                {{ accessoriesTranslations()[performanceAccessory.key] | apmTranslate }}</span
              >
              <div class="flex-1">
                <apm-select
                  [items]="performanceAccessory.value"
                  [disabled]="performanceAccessory.value.length === 1"
                  [ngModel]="selectedAnswers()[model.unitUUID][performanceAccessory.key]"
                  (ngModelChange)="selectedAnswerChanged(model.unitUUID, performanceAccessory.key, $event)"
                  bindLabel="value"
                  bindValue="key"
                ></apm-select>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="modal-footer d-flex justify-content-between mt-4">
    <apm-button variant="secondary" (buttonClick)="closeDialog()">
      {{ '444400' | apmTranslate }}
    </apm-button>
    <div class="d-flex justify-content-end gap-2">
      <apm-button variant="secondary" (buttonClick)="apply()">
        {{ '444737' | apmTranslate }}
      </apm-button>
      @if (data?.allowClone) {
        <apm-button class="min-w-md" (buttonClick)="apply(true)">
          {{ '445133' | apmTranslate }}
        </apm-button>
      }
    </div>
  </div>
</div>
